import React, { useState, useEffect, useCallback, forwardRef } from "react";
import { TextField, InputLabel, Select, MenuItem, FormControl, Input, FormHelperText, InputAdornment } from "@mui/material";
import moment from "moment";
import ModalStyles from "components/Content/Modal/ModalStyles.module.css";
import _ from "lodash";
import { Utils } from "common/Utils";

const viewDataOnly = false
const EmployeeProfile = forwardRef(({ fetchedData, states, maritalStatuses, genders,employmentStatus,employeeGroups, errors }, ref) => {
  const [formData, setFormData] = useState(fetchedData);
  useEffect(() => {
    console.log('ee profile')
  }, []);

  const handleChange = _.debounce((name, val) => {
    console.log(val, 'handle change value')
    console.log(formData, 'handle change formData')
    let updatedValue = { [name]: val };
    setFormData(formData => ({
      ...formData,
      ...updatedValue
    }));
    if (ref?.current) {
      console.log('setting current')
      ref.current.formData = {
        ...formData,
        ...updatedValue
      };
      console.log(ref.current.formData, ' set ref current formData')
    }
  }, 500);

  return (
    <>
      <TextField
        variant="standard"

        className={ModalStyles.cField}
        label="First Name"
        defaultValue={
          formData.firstName === null && viewDataOnly
            ? "N/A"
            : formData.firstName
        }
        onChange={e => handleChange('firstName', e.target.value)}
        error={errors.firstName ? true : false}
        helperText={errors.firstName}
      />
      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
        }}
        className={ModalStyles.cField}
        label="Middle Name"
        defaultValue={
          formData.middleName === null && viewDataOnly
            ? "N/A"
            : formData.middleName
        }
        onChange={e => handleChange('middleName', e.target.value)}
      />
      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
        }}
        className={ModalStyles.cField}
        label="Last Name"
        defaultValue={
          formData.lastName === null && viewDataOnly
            ? "N/A"
            : formData.lastName
        }
        onChange={e => handleChange('lastName', e.target.value)}
        error={errors.lastName ? true : false}
        helperText={errors.lastName}

      />
      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
        }}
        className={ModalStyles.cField}
        label="SSN"
        defaultValue={
          formData.ssn === null && viewDataOnly ? "N/A" : formData.ssn
        }
        onChange={e => handleChange('ssn', e.target.value)}
        error={errors.ssn ? true : false}
        helperText={errors.ssn}
      />

      <FormControl
        className={ModalStyles.cField}
        error={errors.birthDate ? true : false}>
        <InputLabel shrink >Birth Date</InputLabel>
        <Input id="my-input" aria-describedby="my-helper-text" type="date"
          defaultValue={
            (formData.birthDate === null) && viewDataOnly
              ? ""
              : Utils.convertToDatePicker(formData.birthDate)
          }
          onChange={e => handleChange('birthDate', e.target.value)}
        />
        <FormHelperText id="component-error-text">{errors.birthDate}</FormHelperText>
      </FormControl>

      <FormControl sx={{ m: 1, minWidth: 150 }}
        className={ModalStyles.cField}>
        <InputLabel>Gender</InputLabel>
        <Select
          id="genderID"
          name="genderID"
          label="Gender"
          value={formData.genderID || 0}
          required
          shrink
          size="small"
          variant="standard"
          onChange={e => handleChange('genderID', e.target.value)}
        >
          {genders.map((val, i) => <MenuItem value={val.genderId} key={i}>{val.genderName}</MenuItem>)}
        </Select>
      </FormControl>

      <FormControl sx={{ m: 1, minWidth: 150 }}
        className={ModalStyles.cField}>
        <InputLabel>Marital Status</InputLabel>
        <Select
          id="maritalStatusID"
          name="maritalStatusID"
          label="Marital Status"
          value={formData.maritalStatusID || 0}
          required
          shrink
          size="small"
          variant="standard"
          onChange={e => handleChange('maritalStatusID', e.target.value)}
        >
          {maritalStatuses.map((val, i) => <MenuItem value={val.maritalStatusId} key={i}>{val.maritalStatusName}</MenuItem>)}
        </Select>
      </FormControl>

      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
        }}
        className={ModalStyles.cField}
        label="Address 1"
        defaultValue={
          formData.mailingAddress1 === null && viewDataOnly
            ? "N/A"
            : formData.mailingAddress1
        }
        onChange={e => handleChange('mailingAddress1', e.target.value)}
      />
      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
        }}
        className={ModalStyles.cField}
        label="Address 2"
        defaultValue={
          formData.mailingAddress2 === null && viewDataOnly
            ? "N/A"
            : formData.mailingAddress2
        }
        onChange={e => handleChange('mailingAddress2', e.target.value)}
      />
      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
        }}
        className={ModalStyles.cField}
        label="City"
        defaultValue={
          formData.mailingCity === null && viewDataOnly
            ? "N/A"
            : formData.mailingCity
        }
        onChange={e => handleChange('mailingCity', e.target.value)}
      />

      <FormControl sx={{ m: 1, minWidth: 150 }}
        className={ModalStyles.cField}>
        <InputLabel>State</InputLabel>
        <Select
          id="mailingStateID"
          name="mailingStateID"
          label="State"
          value={formData.mailingStateID || states[0].stateId}
          required
          shrink
          size="small"
          variant="standard"
          onChange={e => handleChange('mailingStateID', e.target.value)}
        >
          {states.map((val, i) => <MenuItem value={val.stateId} key={i}>{val.stateAbbr}</MenuItem>)}

        </Select>
      </FormControl>
      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
        }}
        className={ModalStyles.cField}
        label="Zip Code"
        defaultValue={
          formData.mailingZipCode === null && viewDataOnly
            ? "N/A"
            : formData.mailingZipCode
        }
        onChange={e => handleChange('mailingZipCode', e.target.value)}
      />
      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
        }}
        className={ModalStyles.cField}
        label="Email Address"
        defaultValue={
          formData.email === null && viewDataOnly
            ? "N/A"
            : formData.email
        }
        onChange={e => handleChange('email', e.target.value)}
        error={errors.email ? true : false}
        helperText={errors.email}
      />
      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
        }}
        className={ModalStyles.cField}
        label="Home Phone"
        defaultValue={
          formData.homePhone === null && viewDataOnly
            ? "N/A"
            : formData.homePhone
        }
        onChange={e => handleChange('homePhone', e.target.value)}
      />
      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
        }}
        className={ModalStyles.cField}
        label="Work Phone"
        defaultValue={
          formData.workPhone === null && viewDataOnly
            ? "N/A"
            : formData.workPhone
        }
        onChange={e => handleChange('workPhone', e.target.value)}
      />

      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
        }}
        className={ModalStyles.cField}
        label="Job Title"
        defaultValue={
          formData.jobTitle === null && viewDataOnly
            ? "N/A"
            : formData.jobTitle
        }
      />

      <FormControl
        className={ModalStyles.cField}
        error={errors.hireDate ? true : false}>
        <InputLabel shrink >Hire Date</InputLabel>
        <Input id="my-input" aria-describedby="my-helper-text" type="date"
          defaultValue={
            (formData.hireDate === null) && viewDataOnly
              ? ""
              : Utils.convertToDatePicker(formData.hireDate)
          }
          onChange={e => handleChange('hireDate', e.target.value)}
        />
        <FormHelperText id="component-error-text">{errors.hireDate}</FormHelperText>
      </FormControl>

      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
        }}
        className={ModalStyles.cField}
        label="Alt ID"
        defaultValue={
          formData.employeeAltKey === null && viewDataOnly
            ? "N/A"
            : formData.employeeAltKey
        }
      />

<FormControl sx={{ m: 1, minWidth: 150 }}
        className={ModalStyles.cField}
        error={errors.employmentStatusID ? true : false}>
        <InputLabel >Employment Status</InputLabel>
        <Select
          id="employmentStatusID"
          name="employmentStatusID"
          label="Employment Status"
          value={formData.employmentStatusID || ''}
          required
          shrink
          size="small"
          variant="standard"
          onChange={e => handleChange('employmentStatusID', e.target.value)}
        >
          {employmentStatus.map((val, i) => <MenuItem value={val.employmentStatusId} key={i}>{val.employmentStatusName}</MenuItem>)}

        </Select>
        <FormHelperText id="component-error-text">{errors.employmentStatusID}</FormHelperText>
      </FormControl>

      <FormControl sx={{ m: 1, minWidth: 150 }}
        className={ModalStyles.cField}
        error={errors.employeeGroupID ? true : false}>
        <InputLabel >Employee Group</InputLabel>
        <Select
          id="employeeGroupID"
          name="employeeGroupID"
          label="Employee Group"
          value={formData.employeeGroupID || ''}
          required
          shrink
          size="small"
          variant="standard"
          onChange={e => handleChange('employeeGroupID', e.target.value)}
        >
          {employeeGroups.map((val, i) => <MenuItem value={val.employeeGroupId} key={i}>{val.employeeGroupName}</MenuItem>)}

        </Select>
        <FormHelperText id="component-error-text">{errors.employeeGroupID}</FormHelperText>
      </FormControl>
      
      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
        }}
        className={ModalStyles.cField}
        label="Location Code"
        defaultValue={
          formData.locationCode === null && viewDataOnly
            ? "N/A"
            : formData.locationCode
        }
      />
      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
        }}
        className={ModalStyles.cField}
        label="Employee Note"
        defaultValue={
          formData.employeeNote === null && viewDataOnly
            ? "N/A"
            : formData.employeeNote
        }
      />
      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
          startAdornment: <InputAdornment position="start">$</InputAdornment>,
        }}
        className={ModalStyles.cField}
        label="Hourly Salary"
        defaultValue={
          formData.hourlySalary === null && viewDataOnly
            ? "N/A"
            : formData.hourlySalary
        }
      />
      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
          startAdornment: <InputAdornment position="start">$</InputAdornment>,
        }}
        className={ModalStyles.cField}
        label="Weekly Salary"
        defaultValue={
          formData.weeklySalary === null && viewDataOnly
            ? "N/A"
            : formData.weeklySalary
        }
      />
      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
          startAdornment: <InputAdornment position="start">$</InputAdornment>,
        }}
        className={ModalStyles.cField}
        label="Monthly Salary"
        defaultValue={
          formData.monthlySalary === null && viewDataOnly
            ? "N/A"
            : formData.monthlySalary
        }
      />
    </>
  )
});

export default EmployeeProfile;